<template>
  <component :is="cards[`palttype_${chatingPlatId}`]" />
</template>
<script>
import { toRefs, onMounted, reactive, computed, provide } from "vue";
import { useStore } from "vuex";
import xiaohsCard from "./xiaohs/index.vue";
import douyinCard from "./douyin/index.vue";

export default {
  components: { xiaohsCard, douyinCard },
  props: {
    msgItem: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    provide("msgItem", props.msgItem);
    let store = useStore();
    const data = reactive({});

    const chatingPlatId = computed(() => {
      return store.getters["card_store/current_plat_type"];
    });

    const cards = {
      palttype_2: xiaohsCard,
      palttype_1: douyinCard,
    };

    onMounted(() => {});

    return {
      ...toRefs(data),
      chatingPlatId,
      cards,
    };
  },
};
</script>
